<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-02-10 15:20:46
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-07-23 14:17:35
 * @FilePath: \ces-vue-serve\src\views\Chief\contract\common\InvoiceDetails.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- <div style="margin: 0 0 20px">
      <el-button type="primary" :loading="exportLoading" @click="exportData">
        导出开票明细
      </el-button>
    </div> -->
    <el-table v-loading="loading" :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary>
      <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
      <el-table-column prop="kpNumber" label="金税发票号" align="left" />
      <el-table-column prop="kpDate" label="金税开票日期" align="left" />
      <el-table-column prop="productName" label="商品名称" align="left" />
      <el-table-column prop="invoiceCount" label="发票数量" align="left" width="70" />
      <el-table-column prop="invoicePrice" label="发票单价" align="right" header-align="left" width="150" />
      <el-table-column prop="kpAmountAccount" label="含税金额(本币)" align="right" header-align="left" width="150" />
      <el-table-column prop="untaxAmountAccount" label="不含税金额(本币)" align="right" header-align="left" width="150" />
      <el-table-column prop="invoiceCode" label="发票标记" align="left" width="70" />
      <el-table-column prop="taxAccount" label="税金" align="right" header-align="left" width="150" />
      <el-table-column prop="courierNumber" label="发票快递单号" align="left" />
    </el-table>
  </div>
</template>
<script type="es6">
import axios, { getInterInvoiceDetails } from '@/API';
import { downloadBlobFile } from '@/libs/util';
export default {
  props: {
    strContractCode: {
      type: String,
      required: true
    },
    contractId: {
      type: Number,
      default: -1
    },
    typeView: {
      type: String,
      default: ''
    },
    projectName: {
      type: String,
      default: ''
    }
  },

  mounted () {
    this.initData();
  },

  data () {
    return {
      tableData: [],
      loading: false,
      exportLoading: false
    };
  },

  methods: {
    initData () {
      this.loading = true;
      // if (this.typeView === 'return') {
      //   agGetInvoiceDetails({
      //     reContractId: this.contractId || ''
      //   }).then((res) => {
      //     let json = res.data;
      //     this.loading = false;
      //     if (json.status === '200') {
      //       this.tableData = json.data;
      //     }
      //   }).catch(() => {
      //     this.loading = false;
      //   });
      // } else {
      //   getInvoiceDetails(this.strContractCode).then((res) => {
      //     let json = res.data;
      //     this.loading = false;
      //     if (json.status === '200') {
      //       this.tableData = json.data;
      //     }
      //   }).catch(() => {
      //     this.loading = false;
      //   });
      // }
      getInterInvoiceDetails(this.strContractCode, this.projectName).then(res => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '含税金额(本币)') {
          sums[index] = this.kpAmount();
        }
      });
      return sums;
    },
    kpAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += Number(item.kpAmountAccount);
      });
      return cont.toFixed(2);
    },
    // 导出开票明细
    exportData () {
      this.exportLoading = true;
      axios.get('/export/getExporttInvoiceDetailsInfo?contractNum=' + this.strContractCode, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.exportLoading = false;
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '导出开票明细'
        });
      }).catch(() => {
        this.exportLoading = false;
      });
    },
    down (row) {
      console.log(row);
    }
  }
};
</script>
<style lang="less"></style>
